var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#60667C",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.98,
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    y: 10,
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.344 6.501 2.547-2.618a.388.388 0 0 0 0-.541l-.223-.23a.366.366 0 0 0-.527 0L.11 6.23a.383.383 0 0 0-.109.271c0 .103.038.2.109.272l3.03 3.115a.364.364 0 0 0 .526 0l.223-.23a.388.388 0 0 0 0-.54L1.344 6.5z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavClose);
export default __webpack_public_path__ + "static/media/nav-close.2ddce33051a8583e3ceb0feda15dbb09.svg";
export { ForwardRef as ReactComponent };